"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__get_mode = exports.__set_mode = exports.__log = void 0;

var _define = require("./define");

var __Sate__ = {
  mode: _define.BridgeMode.Production
};

var __log = function __log() {
  var _console;

  if (__Sate__.mode == _define.BridgeMode.Production) return;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.unshift('[IJSBridge]');

  (_console = console).log.apply(_console, args);
};
/**
 * 设置开发模式
 */


exports.__log = __log;

var __set_mode = function __set_mode(m) {
  __Sate__.mode = m;
};
/**
 * 获取开发模式
 */


exports.__set_mode = __set_mode;

var __get_mode = function __get_mode() {
  return __Sate__.mode;
};

exports.__get_mode = __get_mode;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdGF0ZS50cyJdLCJuYW1lcyI6WyJfX1NhdGVfXyIsIm1vZGUiLCJCcmlkZ2VNb2RlIiwiUHJvZHVjdGlvbiIsIl9fbG9nIiwiYXJncyIsInVuc2hpZnQiLCJjb25zb2xlIiwibG9nIiwiX19zZXRfbW9kZSIsIm0iLCJfX2dldF9tb2RlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsUUFBUSxHQUFHO0FBQ2ZDLEVBQUFBLElBQUksRUFBRUMsbUJBQVdDO0FBREYsQ0FBakI7O0FBSU8sSUFBTUMsS0FBSyxHQUFHLFNBQVJBLEtBQVEsR0FBb0I7QUFBQTs7QUFDdkMsTUFBSUosUUFBUSxDQUFDQyxJQUFULElBQWlCQyxtQkFBV0MsVUFBaEMsRUFBNEM7O0FBREwsb0NBQWhCRSxJQUFnQjtBQUFoQkEsSUFBQUEsSUFBZ0I7QUFBQTs7QUFFdkNBLEVBQUFBLElBQUksQ0FBQ0MsT0FBTCxDQUFhLGFBQWI7O0FBQ0EsY0FBQUMsT0FBTyxFQUFDQyxHQUFSLGlCQUFlSCxJQUFmO0FBQ0QsQ0FKTTtBQU1QOzs7Ozs7O0FBR08sSUFBTUksVUFBVSxHQUFHLFNBQWJBLFVBQWEsQ0FBQ0MsQ0FBRCxFQUFtQjtBQUMzQ1YsRUFBQUEsUUFBUSxDQUFDQyxJQUFULEdBQWdCUyxDQUFoQjtBQUNELENBRk07QUFJUDs7Ozs7OztBQUdPLElBQU1DLFVBQVUsR0FBRyxTQUFiQSxVQUFhLEdBQWtCO0FBQzFDLFNBQU9YLFFBQVEsQ0FBQ0MsSUFBaEI7QUFDRCxDQUZNIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQnJpZGdlTW9kZSB9IGZyb20gXCIuL2RlZmluZVwiO1xuXG5jb25zdCBfX1NhdGVfXyA9IHtcbiAgbW9kZTogQnJpZGdlTW9kZS5Qcm9kdWN0aW9uXG59O1xuXG5leHBvcnQgY29uc3QgX19sb2cgPSAoLi4uYXJnczogYW55W10pID0+IHtcbiAgaWYgKF9fU2F0ZV9fLm1vZGUgPT0gQnJpZGdlTW9kZS5Qcm9kdWN0aW9uKSByZXR1cm47XG4gIGFyZ3MudW5zaGlmdCgnW0lKU0JyaWRnZV0nKTtcbiAgY29uc29sZS5sb2coLi4uYXJncyk7XG59XG5cbi8qKlxuICog6K6+572u5byA5Y+R5qih5byPXG4gKi9cbmV4cG9ydCBjb25zdCBfX3NldF9tb2RlID0gKG06IEJyaWRnZU1vZGUpID0+IHtcbiAgX19TYXRlX18ubW9kZSA9IG07XG59XG5cbi8qKlxuICog6I635Y+W5byA5Y+R5qih5byPXG4gKi9cbmV4cG9ydCBjb25zdCBfX2dldF9tb2RlID0gKCk6IEJyaWRnZU1vZGUgPT4ge1xuICByZXR1cm4gX19TYXRlX18ubW9kZTtcbn1cbiJdfQ==